export default function(name) {
  for (const meta of document.getElementsByTagName("meta")) {
    if (meta.getAttribute("name") === name) {
      return meta.getAttribute("content");
    }
  }
  return null;
}
